import { useEffect } from 'react';

export function usePreventZoomOut() {
	useEffect(() => {
		const preventPinch = (e: TouchEvent) => {
			if (e.touches.length > 1) {
				e.preventDefault();
			}
		};

		document.addEventListener('touchmove', preventPinch, { passive: false });

		return () => {
			document.removeEventListener('touchmove', preventPinch);
		};
	}, []);
}
